export class LoginCredentials {
    public email!: string;
    public password!: string;
}
